module.exports = __webpack_public_path__ + "static/media/ETHBlack.1b79a806.png";